import React, { useEffect, useState } from "react";
import "./Customer.css";
import { useNavigate } from 'react-router-dom';
import { FaTasks, 
  // FaCalendarAlt, 
  // FaBook, 
  Fa500Px, 
  // FaCreativeCommons,
  FaChartLine, FaBox, FaTools, FaFileInvoice, FaSignOutAlt } from 'react-icons/fa';
import {
  // MdEmail, 
  MdPalette, 
  // MdTimer, 
  MdGavel} from 'react-icons/md';
import BasicColumnChart from "../Diagrams/BasicColumnChart"
import BarChartComponent from "../Diagrams/BarChart";
import DonutChart from "../Diagrams/DonutChart";
import PieChartComponent from "../Diagrams/PieChart";
import LineChart from "../Diagrams/LineChart";
import GeoChart from "../Diagrams/GeoChart";
import NavbarInventory from '../Pages/Navbar/NavbarInventory';
import Profile from '../Images/Phumulani_Ntuli_phototaken_by_ThysDullart.png'
import ScatterPlot from "../Diagrams/ScatterPlot";

function AdminDashboard() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const checkIsMobile = () => {
   const mobileBreakpoint = 768;
   const isMobileDevice = window.innerWidth <= mobileBreakpoint;
   setIsMobile(isMobileDevice);
 };

 // Add event listener for window resize
 useEffect(() => {
   checkIsMobile(); // Initial check
   window.addEventListener("resize", checkIsMobile);
   return () => window.removeEventListener("resize", checkIsMobile);
 }, []);

  const handleLogout = () => {
   localStorage.removeItem('token'); // Clear the token
   navigate('/login'); // Redirect to login page
 };

 return (
   <>
   <div>
   {!isMobile && (
   <div>    
     <NavbarInventory /> 
     <h1 className='collectorHeading'><strong>DASHBOARD</strong></h1>
     <div className="parent">
       <div className="div1 sidenav">
         <h2>CONTROL PANEL</h2>
         <h3>Name and Surname</h3>
           <p>INVENTORY</p>
           <ul className="nav-links">
           
           <li onClick={() => navigate('/dashboard/admin/artwork')}>
               <MdPalette className="nav-icon" />
               <span>Artwork Inventory</span>
             </li>

             <li onClick={() => navigate('/dashboard/artist/artworkinventory')}>
               <MdPalette className="nav-icon" />
               <span>Artwork</span>
             </li>

             {/* <li onClick={() => navigate('/dashboard/admin/image')}>
               <FaBox className="nav-icon" />
               <span>Images</span>
             </li> */}

             {/* <li onClick={() => navigate('/dashboard/admin/certificate')}>
               <FaFileInvoice className="nav-icon" />
               <span>Certificates</span>
             </li> */}

             {/* <p>PRODUCTIVITY</p> */}

             {/* <li onClick={() => navigate('/dashboard/admin/workshop')}>
               <FaBox className="nav-icon" />
               <span>Workshops</span>
             </li> */}


             {/* <li onClick={() => navigate('/dashboard/admin/post')}>
               <FaBox className="nav-icon" />
               <span>Posts</span>
             </li> */}

             {/* <li onClick={() => navigate('/dashboard/admin/research')}>
               <FaBook className="nav-icon" />
               <span>Research</span>
             </li> */}

             {/* <p>MANAGEMENT</p> */}

             {/* <li onClick={() => navigate('/dashboard/admin/proposal')}>
               <Fa500Px className="nav-icon" />
               <span>Proposal</span>
             </li> */}

             <li onClick={() => navigate('/dashboard/admin/task')}>
               <Fa500Px className="nav-icon" />
               <span>Tasks</span>
             </li>

              {/* <li onClick={() => navigate('/dashboard/admin/task')}>
               <MdEmail className="nav-icon" />
               <span>Email</span>
             </li> */}

             {/* <li onClick={() => navigate('/dashboard/admin/application')}>
               <FaBox className="nav-icon" />
               <span>Applications</span>
              </li> */}

               {/* <li onClick={() => navigate('/dashboard/admin/user')}>
               <FaBox className="nav-icon" />
               <span>Users</span>
             </li> */}

             {/* <li onClick={() => navigate('/dashboard/admin/meeting')}>
               <FaCalendarAlt className="nav-icon" />
               <span>Meeting</span>
             </li> */}

              {/* <li onClick={() => navigate('/dashboard/admin/budget')}>
               <FaCalendarAlt className="nav-icon" />
               <span>Budget</span>
             </li> */}

              {/* <li onClick={() => navigate('/dashboard/admin/timeline')}>
               <FaCalendarAlt className="nav-icon" />
               <span>Timeline</span>
             </li> */}

             {/* <li onClick={() => navigate('/dashboard/admin/timesheet')}>
               <MdTimer className="nav-icon" />
               <span>TimeSheet</span>
             </li> */}

             {/* <p>PRODUCTION</p> */}

             <p>BUSINESS</p>

             <li onClick={() => navigate('/dashboard/admin/contract')}>
               <MdGavel className="nav-icon" />
               <span>Contracts</span>
             </li>

             <li onClick={() => navigate('/dashboard/admin/consignment')}>
               <MdGavel className="nav-icon" />
               <span>Consignments</span>
             </li>

             <li onClick={() => navigate('/dashboard/admin/reports')}>
               <FaBox className="nav-icon" />
               <span>Reports</span>
             </li>

             <li onClick={() => navigate('/dashboard/admin/label')}>
               <FaBox className="nav-icon" />
               <span>Labels</span>
             </li>

             <li onClick={() => navigate(
              '/dashboard/admin/sales'
              )}>
               <FaChartLine className="nav-icon" />
               <span>Sales</span>
             </li>

             <li onClick={() => navigate('/dashboard/admin/invoice')}>
               <FaFileInvoice className="nav-icon" />
               <span>Invoices</span>
             </li>

             <li onClick={() => navigate('/user/settings')}>
               <FaTools className="nav-icon" />
               <span>Settings</span>
             </li>

             <li onClick={handleLogout}>
               <FaSignOutAlt className="nav-icon" />
               <span>Logout</span>
             </li>
           </ul>
         </div>

       <div className="div2 card "><h3>Weekly Sales</h3><BasicColumnChart /></div>
       <div className="div3 card"><h3>Monthly Sales</h3><BarChartComponent /></div>
       <div className="div4 card"><h3>Yearly Sales</h3><ScatterPlot /></div>
       <div className="div5 card"><h3>PieChart</h3><DonutChart /></div>
       <div className="div6 card"><h3>LineChart</h3><LineChart /></div>
       <div className="div7 card"><h3>Donut Chart</h3><PieChartComponent /></div>
       <div className="div8 card"><h3>Histogram</h3><PieChartComponent /></div>
       <div className="div9 card"><h3>Intervals</h3><PieChartComponent /></div>
       <div className="div10 card"><h3>GeoChart</h3><GeoChart /></div>            


     </div>
   </div>      
     )}
   </div>

   <div>
   {isMobile && (
     // <div></div>z
   <div className="Customerdashboard_mobile">
     {/* <h1 className='collectorHeading'>Collector Dashboard</h1> */}
     {/* <p className='collectorWelcome'>Welcome, Customer! Manage your account here.</p> */}
     <div className="parent">
       <div className="div1 sidenav">
         <h2>Control Panel</h2>
         <img
           src={Profile}
           alt="Profile"
           className="profile-picture"
         />
         <h3>Name and Surname</h3>
           <ul className="nav-links">
   
             <li onClick={() => navigate('/user/settings')}>
               <FaTasks className="nav-icon" />
               <span>Settings</span>
             </li>

             <li onClick={() => navigate('/user/settings')}>
               <FaBox className="nav-icon" />
               <span>Proposal</span>
             </li>

             <li onClick={() => navigate('/user/settings')}>
               <FaBox className="nav-icon" />
               <span>Posts</span>
             </li>

             <li onClick={() => navigate('/user/settings')}>
               <FaTasks className="nav-icon" />
               <span>Proposal</span>
             </li>

             <li onClick={() => navigate('/dashboard/admin/artwork')}>
               <FaBox className="nav-icon" />
               <span>Inventory</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Research</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>TimeSheet</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Applications</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Workshops</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Contracts</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Users</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Images</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Consignments</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/inventory')}>
               <FaBox className="nav-icon" />
               <span>Reports</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/invoice')}>
               <FaChartLine className="nav-icon" />
               <span>Sales</span>
             </li>

             <li onClick={() => navigate('/dashboard/collaborator/invoice')}>
               <FaFileInvoice className="nav-icon" />
               <span>Invoices</span>
             </li>
             <li onClick={() => navigate('/dashboard/collaborator/invoice')}>
               <FaFileInvoice className="nav-icon" />
               <span>Certificates</span>
             </li>
             <li onClick={handleLogout}>
               <FaSignOutAlt className="nav-icon" />
               <span>Logout</span>
             </li>
           </ul>
         </div>
     </div>
   </div>      
     )}
   </div>

   </>

 );
}




export default AdminDashboard;